import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../../app/SliceUtils";

export const getActivities = createAsyncThunk(
    '/api/activityManagement',
    (_, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/activityManagement`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const postActivity = createAsyncThunk(
    '/api/activityManagement/post',
    (newActivity, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/activityManagement`,
            method: 'POST',
            body: newActivity
        }, rejectWithValue)
);

export const putActivity = createAsyncThunk(
    'api/activityManagement/put',
    (updatedActivity, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/activityManagement`,
            method: 'PUT',
            body: updatedActivity
        }, rejectWithValue)
);

export const deleteActivity = createAsyncThunk(
    '/api/activityManagement/delete',
    (activityId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/activityManagement/${activityId}`,
            method: 'DELETE'
        }, rejectWithValue)
);

export const activityManagementSlice = createSlice({
    name: "activityManagement",
    initialState: {
        activities: { data: null, status: null },
        activityPost: { data: null, status: null },
        activityPut: { data: null, status: null },
        activityDelete: { data: null, status: null },

        selectedActivity: null,
        showFailed: false,
    },
    reducers: {
        selectActivity: (state, action) => {
            state.selectedActivity = action.payload;
        },
        setFailedActivity: (state, action) => {
            state.showFailed = action.payload;
        },
        resetActivityStatus: (state) => {
            ResetSliceState(state);
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, getActivities, 'activities');
        CreateAsyncStatusHandler(builder, postActivity, 'activityPost');
        CreateAsyncStatusHandler(builder, putActivity, 'activityPut');
        CreateAsyncStatusHandler(builder, deleteActivity, 'activityDelete');
    },
});

export const {
    selectActivity,
    resetActivityStatus,
    setFailedActivity,
} = activityManagementSlice.actions;

export default activityManagementSlice.reducer;
